export const environment = {
    apiBaseUrl: 'https://cafs.devtest.gf.aws.scania.com/api/',
    production: true,
    msalConfig: {
        auth: {
            clientId: '38a65446-52c7-46e2-ae9f-c3b1f5b89376',
            authority: 'https://login.microsoftonline.com/3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac'
        },
    },
    webApi: {
        uri: 'https://cafs.devtest.gf.aws.scania.com/api/',
        scopes: ['api://a5e6dfb7-9691-4dfe-a4b0-b77dcb46d065/cafs-api.getpostdelete.any'],
    },
    apiConfig: {
        scopes: ['user.read'],
        uri: 'https://graph.microsoft.com/v1.0/me',
    },
    entraGroup: 'b1bb3ea3-f3e3-4d85-a038-7a77343bc48c'
};
